<section class="tenant-header">
    <div class="logo-wrap" (click)="routeToHome()">
        <img [class]="companyImage === '../../assets/img/1-ez-docs-white.png' ? 'company-img ez-docs' : 'company-img '" src="{{ companyImage }}" alt="company logo" />
        <img
            [class]="productImage === '../../assets/img/ez-docs-logo-white.png' ? 'product-img ez-docs' : 'product-img '"
            src="{{ productImage }}"
            alt="digital product image"
        />
    </div>
</section>
